
import { ITheme } from "@/models/vimy.models";
import { DataStore, EventStore } from "@/store";
import { Options, Vue } from "vue-class-component";
import BusEvent from "../../../../shared/js/BusEvent";

@Options({
  components: {
  },
  props: {
  }
})
export default class Breadcrumb extends Vue {
  themes: ITheme[] = [];
  visitedThemes: number[] = [];
  themesUnwatch!: Function;

  showTheme(id: number) : void
  {
    const eventThemeSet = new BusEvent(BusEvent.EVENTS.CLICK_BREADCRUMBS, {
      theme: id
    });

    document.dispatchEvent(eventThemeSet);

    const eventUI = new BusEvent(BusEvent.EVENTS.PLAY_SOUND, {key: "VM_K_2_", loop: false, group: "UI"});
    document.dispatchEvent(eventUI);
  }

  getImage(id: number) : string | null {
    const theme = this.themes.find(t => t.id == id);
    return theme?.img ?? null;
  }

  getThemeTitle(id: number) {
    let title = this.themes.find(t => t.id == id)?.title;
    if (title)
      return (title as any)[this.$i18n.locale];
    return undefined;
  }

  activated() : void {
    document.addEventListener(BusEvent.EVENTS.BREADCRUMB_VISIBILITY, (event) => {
      const ev = event as BusEvent;
      this.visitedThemes = DataStore.visitedThemes.filter((id, index, self) => self.indexOf(id) === index);
    });

    this.themes = DataStore.themes;
    this.themesUnwatch = DataStore.$watch(t => t.themes, (value, _) => {
      this.themes = value;
    });
  }

  deactivated() : void {
    if (this.themesUnwatch)
      this.themesUnwatch();
  }
}
